import { apiRequest, saveFreeProfile, saveEnterpriseProfile } from './apiClient.js'

export function isEnterpriseAccountType(accountType) {
  return accountType === 'enterprise' || accountType === 'business' || accountType === 'developer'
}

// profileFromAuthResponse turns a login/register or /auth/me response into the
// non-sensitive profile the views gate on (the session itself stays in the HttpOnly cookie).
export function profileFromAuthResponse(data) {
  return {
    email: data.email,
    tenantId: data.tenant_id,
    tenantName: data.tenant_name,
    tier: data.tier,
    accountType: data.account_type || 'individual',
    is_active_subscription: Boolean(data.is_active_subscription),
  }
}

// storeAuthProfile saves the profile under the key matching its account type and clears
// the other, so a stale profile from a previous account can't win loadEnterpriseProfile() ||
// loadFreeProfile().
export function storeAuthProfile(profile) {
  const isEnt = isEnterpriseAccountType(profile.accountType)
  saveEnterpriseProfile(isEnt ? profile : null)
  saveFreeProfile(isEnt ? null : profile)
  return isEnt
}

// restoreSessionFromCookie is the landing half of every SSO flow (Google, Apple, OIDC,
// SAML): the backend has set the session cookie and redirected here with ?sso=<provider>,
// but the frontend has no profile yet. Returns the stored profile, or null when the
// browser didn't send the cookie back (blocked third-party cookies, an expired session).
export async function restoreSessionFromCookie() {
  try {
    const { response } = await apiRequest('/api/v1/auth/me')
    if (!response.ok) return null
    const data = await response.json()
    if (!data?.email) return null
    const profile = profileFromAuthResponse(data)
    storeAuthProfile(profile)
    return profile
  } catch {
    return null
  }
}
